import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import io from 'socket.io-client';
import { baseurl, imageUrl } from '../Baseurl';
import { BiLeftArrow } from 'react-icons/bi'; 
import { ArrowLeft } from 'react-feather';

import { Link, useNavigate } from "react-router-dom";


const socket = io(baseurl.replace('/api', ''));



export default function Chat() {
  const [user, setUser] = useState(null);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [messages, setMessages] = useState([]);
  const [newMsg, setNewMsg] = useState('');
  const [loadingAssignees, setLoadingAssignees] = useState(true);
  const [loadingMessages, setLoadingMessages] = useState(false);
  const scrollRef = useRef();
const navigate = useNavigate();

  useEffect(() => {
    const adminID = localStorage.getItem("adminID");
    if (adminID) {
      axios.get(`${baseurl}getUserById/${adminID}`)
        .then(res => setUser(res.data))
        .catch(err => console.error("Error fetching user:", err));
    }
  }, []);

  useEffect(() => {
    const orgId = localStorage.getItem("organization_id");
    if (orgId) {
      setLoadingAssignees(true);
      axios.get(`${baseurl}getAssigneesByOrgId/${orgId}`)
        .then(res => setUsers(res.data.assignees || []))
        .catch(err => console.error("Error fetching assignees:", err))
        .finally(() => setLoadingAssignees(false));
    }
  }, []);

  useEffect(() => {
    if (user && selectedUser) {
      setLoadingMessages(true);
      socket.emit('getMessages', {
        sender_type: 'user',
        sender_id: user.id,
        receiver_type: 'assignee',
        receiver_id: selectedUser.id,
      });
    }
  }, [user, selectedUser]);

  useEffect(() => {
    socket.on('chatHistory', msgs => {
      setMessages(msgs);
      setLoadingMessages(false);
      scrollToBottom();
    });

    socket.on('newMessage', msg => {
      const isRelevant =
        (msg.sender_id === selectedUser?.id && msg.receiver_id === user?.id) ||
        (msg.sender_id === user?.id && msg.receiver_id === selectedUser?.id);
      if (isRelevant) {
        setMessages(prev => [...prev, msg]);
        scrollToBottom();
      }
    });

    return () => {
      socket.off('chatHistory');
      socket.off('newMessage');
    };
  }, [selectedUser, user]);

  const handleSend = () => {
    if (newMsg.trim()) {
      socket.emit('sendMessage', {
        sender_type: 'user',
        sender_id: user.id,
        receiver_type: 'assignee',
        receiver_id: selectedUser.id,
        message: newMsg
      });
      setNewMsg('');
    }
  };

  const scrollToBottom = () => {
    setTimeout(() => {
      scrollRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  const getDateLabel = (dateStr) => {
    const date = new Date(dateStr);
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    const isSameDate = (d1, d2) =>
      d1.getDate() === d2.getDate() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getFullYear() === d2.getFullYear();

    if (isSameDate(date, today)) return 'Today';
    if (isSameDate(date, yesterday)) return 'Yesterday';
    return date.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
  };

  const groupedMessages = messages.reduce((groups, msg) => {
    const date = new Date(msg.created_at || msg.timestamp);
    const key = date.toDateString();
    if (!groups[key]) groups[key] = [];
    groups[key].push(msg);
    return groups;
  }, {});

  const sortedDates = Object.keys(groupedMessages).sort(
    (a, b) => new Date(a) - new Date(b)
  );

  return (
    <div className="chat-container d-flex" style={{ height: '100vh', border: '1px solid #ddd' }}>
      
      {/* LEFT: User List */}
      <div className="chat-users border-end" style={{ width: '25%', overflowY: 'auto' }}>
        <div className="p-3 border-bottom bg-light fw-bold"><Link onClick={() => navigate(-1)} ><ArrowLeft /> </Link>Users</div>
        {loadingAssignees ? (
          <div className="d-flex justify-content-center p-4">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          users.map(u => (
            <div
              key={u.id}
              onClick={() => setSelectedUser(u)}
              className={`p-2 d-flex align-items-center border-bottom chat-user-item ${selectedUser?.id === u.id ? 'bg-danger text-white' : ''}`}
              style={{ cursor: 'pointer' }}
            >
              <img
                src={`${imageUrl}assignee/${u.profile_image}`}
                alt={u.full_name}
                className="rounded-circle me-2"
                width="40"
                height="40"
              />
              <div>
                <div className="fw-bold">{u.full_name}</div>
                <small className={` ${selectedUser?.id === u.id ? ' text-white' : 'text-dark'}`}>{u.department} • {u.role}</small>
              </div>
            </div>
          ))
        )}
      </div>

      {/* RIGHT: Chat Box */}
      <div className="chat-box d-flex flex-column w-100">
        <div className="p-3 border-bottom bg-light fw-bold">
          {selectedUser ? `${selectedUser.full_name}` : 'Select a user to start chat'}
        </div>

        <div className="flex-grow-1 p-3 overflow-auto" style={{ background: '#f9f9f9' }}>
          {loadingMessages ? (
            <div className="d-flex justify-content-center align-items-center h-100">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading chat...</span>
              </div>
            </div>
          ) : (
            <>
              {sortedDates.map(dateStr => {
                const msgs = groupedMessages[dateStr];
                const label = getDateLabel(dateStr);

                return (
                  <div key={dateStr}>
                    <div className="text-center text-muted my-2 fw-semibold"><span className='dthj'>{label}</span></div>
                    {msgs.map((msg, idx) => {
                      const date = new Date(msg.created_at || msg.timestamp);
                      const formattedTime = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

                      return (
                        <div
                          key={idx}
                          className={`mb-3 ${msg.sender_id === user?.id ? 'text-end' : 'text-start'}`}
                        >
                          <div
                            className={`d-inline-block p-2 ${msg.sender_id === user?.id ? 'bg-chat1 text-dark' : 'bg-chat2'}`}
                            style={{ maxWidth: '75%' }}
                          >
                            <div className='ft-13'>{msg.message}</div>
                            <div className="mt-1 text-muted small" style={{ fontSize: '0.75rem' }}>
                              {formattedTime}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                );
              })}
              <div ref={scrollRef}></div>
            </>
          )}
        </div>

        <div className="p-3 border-top d-flex">
          <input
            type="text"
            className="form-control me-2"
            placeholder="Type message..."
            value={newMsg}
            onChange={(e) => setNewMsg(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleSend()}
            disabled={!selectedUser || loadingMessages}
          />
          <button className="btn btn-primary" onClick={handleSend} disabled={!selectedUser || loadingMessages}>Send</button>
        </div>
      </div>
    </div>
  );
}
